import React from 'react'

const Social = ({isDarkMode}) => {
    const bodyClass = `home__social ${isDarkMode ? "dark-mode" : ""}`;

    return (
        <div className={bodyClass}>
            <a href="https://www.linkedin.com/in/kumail-rizvi-2772071a0/" className="home__social-icon" target='_blank'>
                <i className="uil uil-linkedin-alt"></i>
            </a>

            <a href="https://twitter.com/sayedkumail_" className="home__social-icon" target='_blank'>
                <i className="uil uil-twitter-alt"></i>
            </a>
            
            <a href="https://github.com/Skumail-code" className="home__social-icon" target='_blank'>
                <i className="uil uil-github-alt"></i>
            </a>
        </div>
    )
}

export default Social
